import { Injectable } from "@angular/core";
import { ActivatedRouteSnapshot, CanActivate } from "@angular/router";
import { CCPAParams, SourceChannel, LANGUAGE, Product, products } from "@prequalification/models";
import { ProductService } from "@prequalification/services";

declare global {
  interface Window {
    isExisting: boolean;
  }
}

@Injectable()
export class SetCcpaParamGuard implements CanActivate {
  private readonly RBC_LINK = "https://www.rbc.com";

  constructor(private productService: ProductService) {}

  canActivate(route: ActivatedRouteSnapshot): boolean {
    this.productService.pid = route.queryParams[CCPAParams.PID_PARAM] ?? "";
    this.productService.campaignCode = route.queryParams[CCPAParams.CAMPAIGN_CODE_PARAM] ?? "";
    this.productService.chnl = route.queryParams[CCPAParams.CHANNEL_PARAM] ?? SourceChannel.CCPA;
    this.productService.lang =
      route.queryParams[CCPAParams.LANGUAGE] &&
      route.queryParams[CCPAParams.LANGUAGE].length > 0 &&
      [LANGUAGE.EN, LANGUAGE.FR].includes(route.queryParams[CCPAParams.LANGUAGE].toLowerCase())
        ? route.queryParams[CCPAParams.LANGUAGE].toLowerCase()
        : LANGUAGE.EN;

    if (this.productService.pid.length === 0) {
      this.navigateToRBC();
    }

    const product: Product | null =
      products.find((product: Product) => product.id.toLowerCase() === this.productService.pid.toLowerCase()) ?? null;
    if (!product) {
      this.navigateToRBC();
    }

    return true;
  }

  private navigateToRBC() {
    window.location.href = this.RBC_LINK;
  }
}
